import UserInterface_ from '../UserInterface_/UserInterface_'

var container = document.getElementById('globe') || {}

export default container
